import { render, staticRenderFns } from "./GPSRInfoCreatePage.vue?vue&type=template&id=0f0dddf8&scoped=true&"
import script from "./GPSRInfoCreatePage.vue?vue&type=script&lang=ts&"
export * from "./GPSRInfoCreatePage.vue?vue&type=script&lang=ts&"
import style0 from "./GPSRInfoCreatePage.vue?vue&type=style&index=0&id=0f0dddf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0dddf8",
  null
  
)

export default component.exports